module.exports = __webpack_public_path__ + "static/media/lk.bf15b308.svg";